import * as React from "react";

import { Button } from "semantic-ui-react";

import { TaskModel } from "@teamprevent/common/task/taskActions/models";

const ViewBloodTestResultEvidenceButton: React.FunctionComponent<{ task: TaskModel }> = (props) => {
    // eslint-disable-next-line max-len
    const downloadUrl = `/api/customer/${props.task.customer.id}/employeeRecord/${props.task.employeeRecord.id}/immunisationCase/${props.task.caseId}/bloodtestresultevidence/${props.task.id}`;
    return (
        <a href={downloadUrl}><Button content="View Evidence" floated="right" /></a>
    );
};

export { ViewBloodTestResultEvidenceButton };
